import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  CustomDataTableHeader,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  PageHeader,
  Periodo,
  PrestacaoContasStatus,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { withRouter } from 'react-router-dom'
import { convertToJsDate, getPeriodoMesAtual } from '../../../../services/util/date.service'
import ModalMovimentacaoLastMile from './ModalMovimentacaoLastMile'
import { showMessageBox } from '../../../../store/actions/system.actions'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import ModalResumoPrestacaoContas from './ModalResumoPrestacaoContas/ModalResumoPrestacaoContas'

const { dataInicial, dataFinal } = getPeriodoMesAtual()

const DROPDOWN_OPTIONS = [
  { label: 'Pendente', value: 'Pendente' },
  { label: 'Em Validação', value: 'Em Validação' },
  { label: 'Finalizada', value: 'Finalizada' },
]

function MovimentacaoLastMile({ dispatch, history, selectedTp }) {
  const [movimentacoes, setMovimentacoes] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [selectedMovimentacao, setSelectedMovimentacao] = useState(null)
  const [modalResumo, setModalResumo] = useState({ show: false, data: null })
  const [isLoading, setIsLoading] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(['Pendente', 'Em Validação', 'Finalizada'])
  const [selectedTransportadora, setSelectedTransportadora] = useState(0)
  const [transportadoras, setTransportadoras] = useState(null)
  const [movimentacoesFiltered, setMovimentacoesFiltered] = useState([])

  useEffect(() => {
    getMovimentacoesLastMile(dataInicial, dataFinal)
  }, [selectedTp])

  useEffect(() => {
    filterMovimentacoes(selectedStatus, selectedTransportadora)
  }, [selectedStatus, selectedTransportadora, movimentacoes])

  // Events
  const onNovoClick = () => {
    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione o Operador Logístico'))
    } else {
      setSelectedMovimentacao({
        id: null,
        data_movimentacao: '',
        selectedPlaca: '',
        selectedTransportadora: '',
        ativos: [],
      })
    }
  }

  const onPesquisar = (pInicial, pFinal) => {
    if (selectedStatus.length === 0)
      dispatch(showMessageBox(null, 'Você precisa selecionar pelo menos um status.'))
    else getMovimentacoesLastMile(pInicial, pFinal, selectedTransportadora, selectedStatus)
  }

  const onMenuItemClick = (menuItem, item) => {
    switch (menuItem) {
      case 'Editar':
        if (selectedTp === 0) {
          dispatch(showMessageBox(null, 'Selecione o Operador Logístico'))
        } else if (item && item.prestacao_conta_status !== 'Pendente') {
          dispatch(showMessageBox(null, 'Esta movimentação NÃO pode ser Editada'))
        } else {
          setSelectedMovimentacao({
            ...item,
            data_movimentacao: convertToJsDate(item.data_movimentacao),
            selectedPlaca: '',
            selectedTransportadora: '',
          })
        }
        break
      case 'Prestação de Contas':
        history.push('/main/patrimonio/prestacao-contas', { item })
        break
      case 'Emitir Comprovante':
        MovimentacaoLastMileHttp.emitirComprovante(item.id)
        break
      case 'Resumo Prestação de Contas':
        setModalResumo({ show: true, data: item })
        break
      default:
        throw new Error('Menu Item NÃO encontrado')
    }
  }

  const onModalResponse = (action, payload) => {
    if (action === 'close') setSelectedMovimentacao(null)
    else if (action === 'error') dispatch(showMessageBox(null, payload))
    else if (action === 'success') {
      const index = movimentacoes.findIndex(m => m.id === payload.id)
      if (index !== -1) {
        setMovimentacoes(prevState => {
          prevState[index] = payload
          return [...prevState]
        })
      } else {
        setMovimentacoes(prevState => {
          prevState.unshift(payload)
          return [...prevState]
        })
      }

      setTransportadoras(prevState => {
        const transportadorasFiltered = Array.from(
          new Set(
            [
              ...prevState,
              { label: payload.transportadora_name, value: payload.transportadora_id },
            ].map(JSON.stringify),
          ),
        ).map(JSON.parse)
        return [...transportadorasFiltered]
      })

      setSelectedMovimentacao(null)
    }
  }

  const onModalResumoResponse = (action, payload) => {
    switch (action) {
      case 'close':
        setModalResumo({ show: false, data: null })
        break

      default:
        break
    }
  }

  // Helpers
  const getMovimentacoesLastMile = (pInicial, pFinal) => {
    setIsLoading(true)
    let tpsIds = []
    if (selectedTp === 0) {
      tpsIds = getTps()
        .filter(tp => tp.id !== 0)
        .map(tp => tp.id)
    } else {
      tpsIds = [selectedTp]
    }
    MovimentacaoLastMileHttp.getMovimentacoesLastMile(pInicial, pFinal, tpsIds)
      .then(mov => {
        setMovimentacoes(mov)
        const transportadorasFiltered = Array.from(
          new Set(
            [
              { label: 'Todos', value: 0 },
              ...mov.map(m => ({ label: m.transportadora_name, value: m.transportadora_id })),
            ].map(JSON.stringify),
          ),
        ).map(JSON.parse)
        setTransportadoras(transportadorasFiltered)
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
        setIsLoading(false)
      })
  }

  const filterMovimentacoes = (selectedStatus, selectedTransportadora) => {
    let filteredMovimentacoes = []

    if (selectedTransportadora === 0)
      filteredMovimentacoes = movimentacoes.filter(m =>
        selectedStatus.includes(m.prestacao_conta_status),
      )
    else
      filteredMovimentacoes = movimentacoes.filter(
        m =>
          selectedStatus.includes(m.prestacao_conta_status) &&
          m.transportadora_id === selectedTransportadora,
      )

    setMovimentacoesFiltered(filteredMovimentacoes)
  }

  //Render
  return (
    <>
      <PageHeader>6.4 - Movimentação - Last Mile</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onNovoClick} onVoltar={history.goBack}>
          <div className="p-grid p-align-center">
            <div className="p-col-2">
              <CustomMultiSelect
                options={DROPDOWN_OPTIONS}
                label="Status"
                value={selectedStatus}
                onChange={value => setSelectedStatus(value)}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                options={transportadoras}
                label="Transportadoras"
                value={selectedTransportadora}
                onChange={value => setSelectedTransportadora(value)}
              />
            </div>
            <div className="p-col-4">
              <Periodo
                periodoInicial={dataInicial}
                periodoFinal={dataFinal}
                onPesquisar={onPesquisar}
              />
            </div>
            <div className="p-col-12">
              <DataTable
                loading={isLoading}
                value={movimentacoesFiltered}
                emptyMessage={'Não existe movimentação para o Período selecionado'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered(80)} />
                <Column field={'data_movimentacao'} header={'Data'} style={tableCellCentered()} />
                <Column field={'placa'} header={'Placa'} />
                <Column field={'transportadora_name'} header={'Transportadora'} />
                <Column
                  header={'Status'}
                  style={tableCellCentered(150)}
                  body={mov => <PrestacaoContasStatus status={mov.prestacao_conta_status} />}
                />
                <Column
                  header={'#'}
                  body={item => (
                    <ThreeDots
                      items={[
                        'Editar',
                        'Prestação de Contas',
                        'Emitir Comprovante',
                        'Resumo Prestação de Contas',
                      ]}
                      onClick={menuItem => onMenuItemClick(menuItem, item)}
                    />
                  )}
                  style={tableCellCentered(80)}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalMovimentacaoLastMile
        selectedTp={selectedTp}
        onResponse={onModalResponse}
        visible={selectedMovimentacao !== null}
        selectedMovimentacao={selectedMovimentacao}
      />
      <ModalResumoPrestacaoContas modal={modalResumo} onResponse={onModalResumoResponse} />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoLastMile))
